var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7999 11.912C25.7999 11.912 25.6049 10.589 25.0053 10.0065C24.2445 9.2429 23.3923 9.2384 23.0016 9.19511C20.2026 9 16.0044 9 16.0044 9H15.995C15.995 9 11.7968 9 8.99844 9.19511C8.60769 9.2384 7.75617 9.2429 6.99469 10.0065C6.39575 10.589 6.20006 11.912 6.20006 11.912C6.20006 11.912 6 13.4644 6 15.0168V16.4719C6 18.0255 6.20006 19.5773 6.20006 19.5773C6.20006 19.5773 6.39512 20.8998 6.99469 21.4812C7.75617 22.2447 8.75461 22.2217 9.19975 22.3015C10.7996 22.4488 16 22.4944 16 22.4944C16 22.4944 20.2026 22.4876 23.0016 22.2948C23.3923 22.2498 24.2445 22.2453 25.0053 21.4817C25.6043 20.9003 25.7999 19.5779 25.7999 19.5779C25.7999 19.5779 26 18.0255 26 16.4725V15.0174C26 13.4644 25.7999 11.912 25.7999 11.912Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.502 12.3735V19.1207L19.7539 15.7471L13.502 12.3735Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter7);
export default __webpack_public_path__ + "static/media/footer7.96ba992f1502b1250975b2930e5509a6.svg";
export { ForwardRef as ReactComponent };